import { useState, Fragment, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchinvoicehistory,
  invoicehistorySelector,
  invoicehistoryactions,
} from "@slices/Enquiry/Invoices/InvoiceHistory";
import { Link, useLocation } from "react-router-dom";
import {
  ArrowUpSVG,
  ArrowDownSVG,
  Info_Order,
  LeftSVG,
  RightSVG,
  PreviousArrow,
} from "@icons";
import { useGetLoggedInUserInfo } from "@hooks";
import NoData from "@common/NoData";
import styled from "styled-components";
import LoadingOverlay from "@common/LoadingOverlay";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import { useTranslation } from "react-i18next";
import { INVOICEDETAIL } from "@constants/Routes";
import { useURLPagination } from "@hooks";

const PaginationContainer = styled.div`
  float: right;
  margin-top: -55px;
  padding: 0px 18px;
`;

const InvoiceTable = () => {
  const sessionId = useGetLoggedInUserInfo()?.sessionId;
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [filterPageNo, setFilterPageNo] = useState<any>(1);
  const webSettings: any = useContext(WebSettingsContext);
  const { t, i18n } = useTranslation();
  const previousP = location?.state?.previousPage;

  const [currentinvoiceNumberSort, setCurrentinvoiceNumberSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_ASCENDING")}
      onClick={() => fetchASCsortorder("InvoiceNumber")}
    >
      <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
    </a>
  );
  const [currentinvoiceDateSort, setCurrentinvoiceDateSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("invoiceDate")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentTypeSort, setCurrentTypeSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("Type")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentCustomerSort, setCurrentCustomerSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("Customer")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentAmountIncludingVATSort, setCurrentAmountIncludingVATSort] =
    useState(
      <a
        title={t("CON_CLICK_TO_SORT_DESCENDING")}
        onClick={() => fetchDESCsortorder("AmountIncludingVAT")}
      >
        <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
      </a>
    );
  const [currentorderNumberSort, setCurrentorderNumberSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("orderNumber")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentorderDateSort, setCurrentorderDateSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("orderDate")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentsalesmanSort, setCurrentsalesmanSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("salesman")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentyourReferrenceSort, setCurrentyourReferrenceSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("yourReferrence")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );

  const [sortcolumn, setSortColumn] = useState({
    SortColumn: "invoiceNumber",
    orderBy: "DESC",
  });

  function fetchASCsortorder(type: string) {
    if (type == "InvoiceNumber") {
      setCurrentinvoiceNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("InvoiceNumber")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "invoiceNumber", orderBy: "ASC" });
    } else if (type == "invoiceDate") {
      setCurrentinvoiceDateSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("invoiceDate")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "invoiceDate", orderBy: "ASC" });
    } else if (type == "Type") {
      setCurrentTypeSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("Type")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Type", orderBy: "ASC" });
    } else if (type == "Customer") {
      setCurrentCustomerSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("Customer")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Customer", orderBy: "ASC" });
    } else if (type == "AmountIncludingVAT") {
      setCurrentAmountIncludingVATSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("AmountIncludingVAT")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "AmountIncludingVAT", orderBy: "ASC" });
    } else if (type == "orderNumber") {
      setCurrentorderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("orderNumber")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "orderNumber", orderBy: "ASC" });
    } else if (type == "orderDate") {
      setCurrentorderDateSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("orderDate")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "orderDate", orderBy: "ASC" });
    } else if (type == "salesman") {
      setCurrentsalesmanSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("salesman")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "salesman", orderBy: "ASC" });
    } else if (type == "yourReferrence") {
      setCurrentyourReferrenceSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("yourReferrence")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "yourReferrence", orderBy: "ASC" });
    }
  }

  function fetchDESCsortorder(type: string) {
    if (type == "InvoiceNumber") {
      setCurrentinvoiceNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("InvoiceNumber")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "InvoiceNumber", orderBy: "DESC" });
    } else if (type == "invoiceDate") {
      setCurrentinvoiceDateSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("invoiceDate")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "invoiceDate", orderBy: "DESC" });
    } else if (type == "Type") {
      setCurrentTypeSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("Type")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Type", orderBy: "DESC" });
    } else if (type == "Customer") {
      setCurrentCustomerSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("Customer")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Customer", orderBy: "DESC" });
    } else if (type == "AmountIncludingVAT") {
      setCurrentAmountIncludingVATSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("AmountIncludingVAT")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "AmountIncludingVAT", orderBy: "DESC" });
    } else if (type == "orderNumber") {
      setCurrentorderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("orderNumber")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "orderNumber", orderBy: "DESC" });
    } else if (type == "orderDate") {
      setCurrentorderDateSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("orderDate")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "orderDate", orderBy: "DESC" });
    } else if (type == "salesman") {
      setCurrentsalesmanSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("salesman")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "salesman", orderBy: "DESC" });
    } else if (type == "yourReferrence") {
      setCurrentyourReferrenceSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("yourReferrence")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "yourReferrence", orderBy: "DESC" });
    }
  }

  const state = useSelector(invoicehistorySelector);
  const searchFilters = state?.invoiceHistory?.searchFilters;
  const loading = state?.invoiceHistory?.loading;

  useURLPagination({
    page: [pageNumber, (val: string) => setPageNumber(+val)],
    filterPageNo: [filterPageNo, (val: string) => setFilterPageNo(+val)],
  });

  useEffect(() => {
    if (previousP !== undefined) {
      setPageNumber(previousP);
    }
  }, [previousP]);

  useEffect(() => {
    if (state?.invoiceHistory?.isFilterApply) {
      setSortColumn({ SortColumn: "invoiceNumber", orderBy: "ASC" });
      setCurrentinvoiceNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("InvoiceNumber")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
    } else {
      setSortColumn({ SortColumn: "invoiceNumber", orderBy: "DESC" });
      setCurrentinvoiceNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("InvoiceNumber")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
    }
  }, [state?.invoiceHistory?.isFilterApply, searchFilters]);

  useEffect(() => {
    return () => {
      dispatch(invoicehistoryactions.clearSearchFilter());
    };
  }, []);

  useEffect(() => {
    if (sessionId) {
      dispatch(invoicehistoryactions.intitalizeLoader());
      if (state?.invoiceHistory?.isFilterApply) {
        setPageNumber(1);
        dispatch(
          fetchinvoicehistory(
            sessionId,
            sortcolumn.orderBy,
            sortcolumn.SortColumn,
            filterPageNo,
            true,
            searchFilters.customerSearch,
            searchFilters.invoicenoSearch,
            searchFilters.ordernoSearch,
            searchFilters.orderrefSearch,
            searchFilters.yourordernoSearch,
            searchFilters.invoiceCustomerSearch,
            searchFilters.productSearch,
            searchFilters.descriptionSearch,
            searchFilters.addressSearch,
            searchFilters.serialnoSearch,
            searchFilters.invoiceTypeSearch,
            searchFilters.salesPersonSearch
          )
        );
      } else {
        setFilterPageNo(1);
        dispatch(
          fetchinvoicehistory(
            sessionId,
            sortcolumn.orderBy,
            sortcolumn.SortColumn,
            pageNumber
          )
        );
      }
    }
  }, [sessionId, sortcolumn, pageNumber, filterPageNo]);

  const handleNextPage = () => {
    state?.invoiceHistory?.isFilterApply
      ? setFilterPageNo((prevstate: any) => prevstate + 1)
      : setPageNumber((prevstate: any) => prevstate + 1);
  };

  const handlePrevPage = () => {
    state?.invoiceHistory?.isFilterApply
      ? setFilterPageNo((prevstate: any) => prevstate - 1)
      : setPageNumber((prevstate: any) => prevstate - 1);
    /* to solve the issue of not changing url page number from 2 to 1 */
    if (pageNumber === 2) {
      localStorage.setItem("paginationString", "page=1&filterPageNo=1");
    }
  };

  const handleFirstPage = () => {
    state?.invoiceHistory?.isFilterApply
      ? setFilterPageNo(1)
      : setPageNumber(1);
    /* to solve the issue of not changing url page number from 2 to 1 */
    localStorage.setItem("paginationString", "page=1&filterPageNo=1");
  };

  return (
    <Fragment>
      <PaginationContainer>
        {state?.invoiceHistory?.invoices?.invoiceHistoryBean?.length > 0 && (
          <div className="custom-pagination">
            <a
              onClick={handleFirstPage}
              title={t("CON_FIRST_PAGE")}
              className={`default ${
                pageNumber == 1 && filterPageNo == 1 ? "disable" : ""
              }`}
            >
              <PreviousArrow className="icon-color" />
            </a>
            <a
              onClick={() => handlePrevPage()}
              title={t("CON_PREVIOUS_PAGE")}
              className={`default ${
                pageNumber == 1 && filterPageNo == 1 ? "disable" : "default"
              }`}
            >
              <LeftSVG className="icon-color" />
            </a>
            <a
              onClick={() => handleNextPage()}
              title={t("CON_NEXT")}
              className={`default ${
                !state?.invoiceHistory?.invoices?.moreRecords ? "disable" : ""
              }`}
            >
              <RightSVG className="icon-color" />
            </a>
          </div>
        )}
      </PaginationContainer>
      <div className="card-table">
        <div className="card-thead">
          <div className="row">
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> #{t("COH_INVOICE")}</div>
                <div className="col-sort">{currentinvoiceNumberSort}</div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("COH_DOCUMENT_DATE")}</div>
                <div className="col-sort">{currentinvoiceDateSort}</div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("COH_TYPE")}</div>
                <div className="col-sort">{currentTypeSort}</div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("COH_INVOICE_CUSTOMER")}</div>
                <div className="col-sort">{currentCustomerSort}</div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex">
                <div className="col-title">{t("COH_AMOUNT_INCLUDING_VAT")}</div>
                <div className="col-sort">{currentAmountIncludingVATSort}</div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("COH_ORDER_NUMBER")}</div>
                <div className="col-sort">{currentorderNumberSort}</div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("COH_ORDER_DATE")}</div>
                <div className="col-sort">{currentorderDateSort}</div>
              </div>
            </div>
            {webSettings?.showSalesMan && (
              <div className="col">
                <div className="d-flex">
                  <div className="col-title"> {t("COH_SALESMAN")}</div>
                  <div className="col-sort">{currentsalesmanSort}</div>
                </div>
              </div>
            )}
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("CON_YOUR_ORDER")}#</div>
                <div className="col-sort">{currentyourReferrenceSort}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-tbody">
          {state?.invoiceHistory?.invoices?.invoiceHistoryBean?.length == 0 && (
            <NoData />
          )}
          {state?.invoiceHistory?.invoices?.invoiceHistoryBean?.map(
            (items: any) => {
              return (
                <div className="row">
                  <div className="col">
                    <div className="flex-container">
                      <div className="label"># {t("COH_INVOICE")}</div>
                      <div>
                        <Link
                          to={{
                            pathname: INVOICEDETAIL,
                            state: {
                              invoicenumber: `${items.invoiceNumber}`,
                              ordernumber: `${items.orderNumber}`,
                              documenttype: `${items.documentType}`,
                              invoicetype: `${items.typeCode}`,
                              invoiceyear: `${items.invoiceYear}`,
                              previousPageNo: pageNumber,
                            },
                          }}
                        >
                          {items.invoiceNumber}
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="flex-container">
                      <div className="label">{t("COH_DOCUMENT_DATE")}</div>
                      <div>{items.invoiceDate}</div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="flex-container">
                      <div className="label">{t("COH_TYPE")}</div>
                      <div>{items.typeDescription}</div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="flex-container">
                      <div className="label">{t("COH_INVOICE_CUSTOMER")}</div>
                      <div>{items.invoiceCustomer}</div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="flex-container">
                      <div className="label">
                        {t("COH_AMOUNT_INCLUDING_VAT")}
                      </div>
                      <div>{items.amount}</div>
                    </div>
                  </div>
                  <div className="col order-value-position">
                    <div className="flex-container">
                      <div className="label">{t("COH_ORDER_NUMBER")}</div>
                      <div>{items.orderNumber}</div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="flex-container">
                      <div className="label">{t("COH_ORDER_DATE")}#</div>
                      <div>{items.orderDate}</div>
                    </div>
                  </div>
                  {webSettings?.showSalesMan && (
                    <div className="col">
                      <div className="flex-container">
                        <div className="label">{t("COH_SALESMAN")}</div>
                        <div>{items.salesman}</div>
                      </div>
                    </div>
                  )}
                  <div className="col">
                    <div className="flex-container">
                      <div className="label">{t("CON_YOUR_ORDER")}#</div>
                      <div>{items.yourReferrence}</div>
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
      <LoadingOverlay active={loading} />
    </Fragment>
  );
};

export default InvoiceTable;
